<template>
    <div :style="{ display: (showChild ? 'block' : 'none'), marginLeft: (showNode ? '34px' : '') }">
            <slot>

            </slot>
        </div>
</template>
<script>

export default {
    props: {
        showNode:{type:Boolean},
        showChild:{type:Boolean}
    },
    computed: {
        
    },
    data: function () {
        return {
            
        };
    },
    methods: {
        
    },
    watch: {
       
    },
    created: function () {
        
    },
    mounted: function () {
        
    },
    destroyed: function () {

    }
}
</script>